import React, { useState } from 'react'

// material ui
import Box from '@mui/material/Box'

// components
import PaymentMethodForm from 'components/shared/PaymentMethodForm'
import NavButtons from 'components/register/shared/NavButtons'

const PaymentForm = props => {
  const {
    pathname, // via withPathname
    account, // via query
    onClickContinue, // via withEventHandlers
    mutationLoading // via withMutation
  } = props

  const [paymentReady, setPaymentReady] = useState(false)

  return (
    <>
      <PaymentMethodForm
        headerText='Select Payment Method'
        account={account}
        onReady={() => setPaymentReady(true)}
      />

      {/* Stripe Elements validates the payment method via elements.submit() */}
      <Box my={4}>
        <NavButtons
          account={account}
          pathname={pathname}
          mutationLoading={mutationLoading}
          disableContinue={mutationLoading || !paymentReady}
          onClickContinue={onClickContinue}
        />
      </Box>
    </>
  )
}

export default PaymentForm
